import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getUserPreferences as fetchUserPreferencesApi,
  patchUserPreferences as patchUserPreferencesApi,
} from "../../Services/UserPreferences";
import {
  IUserPreferences,
  UserPreferencesPatch,
} from "../../interfaces/models/IUserPreferences";

export const fetchUserPreferences = createAsyncThunk(
  "userPreferences/fetch",
  async (_, { getState }) => {
    const state = (getState() as { userPreferences: { userPreferences: IUserPreferences | null } })
      ?.userPreferences;
    if (state?.userPreferences != null) {
      return state.userPreferences;
    }
    const data = await fetchUserPreferencesApi();
    return data;
  }
);

export const patchUserPreferencesThunk = createAsyncThunk(
  "userPreferences/patch",
  async (partial: UserPreferencesPatch) => {
    const updated = await patchUserPreferencesApi(partial);
    return updated;
  }
);

interface UserPreferencesState {
  userPreferences: IUserPreferences | null;
  loading: boolean;
  error: Error | null;
}

const initialState: UserPreferencesState = {
  userPreferences: null,
  loading: true,
  error: null,
};

const userPreferencesSlice = createSlice({
  name: "userPreferences",
  initialState,
  reducers: {
    clearUserPreferences: (state) => {
      state.userPreferences = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserPreferences.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserPreferences.fulfilled, (state, action) => {
        state.loading = false;
        state.userPreferences = action.payload;
        state.error = null;
      })
      .addCase(fetchUserPreferences.rejected, (state, action) => {
        state.loading = false;
        state.userPreferences = null;
        state.error = action.error as Error;
      })
      .addCase(patchUserPreferencesThunk.pending, () => {})
      .addCase(patchUserPreferencesThunk.fulfilled, (state, action) => {
        state.userPreferences = action.payload;
      })
      .addCase(patchUserPreferencesThunk.rejected, () => {});
  },
});

export const { clearUserPreferences } = userPreferencesSlice.actions;
export const userPreferencesReducer = userPreferencesSlice.reducer;
